module.exports = __webpack_public_path__ + "static/media/pdf.66c9b311.svg";